/* eslint-disable react/prop-types */

import { customGroupStatus } from '@helpers';
import { BookBookmarkIcon, Tag, TagLockIcon, TagShareIcon } from '@utilities';

import CustomGroupStatus from '../../../components/CustomGroupStatus';

import workspaceStyles from '../../../_index.module.scss';

export const getItemColumns = ({ groupOverrides }) => [
  {
    accessor: 'name',
    Cell: ({ row }) => {
      return <span>{row?.original?.name}</span>;
    },
    Header: 'Name',
    width: 250,
  },
  {
    accessor: 'status',
    Cell: ({ row }) => {
      return <CustomGroupStatus group={row?.original} />;
    },
    disableSortBy: true,
    Header: 'Status',
    width: 100,
  },
  {
    Cell: ({ row }) => {
      const groupOverride = groupOverrides?.[row?.original?.id];
      const status = groupOverride?.status ?? row?.original?.status;
      const isCompatible = groupOverride
        ? groupOverride.isNarrativesCompatible
        : row?.original?.isNarrativesCompatible;

      return (
        <span className={workspaceStyles['workspace-tags-cell']}>
          {row?.original?.isShared && <Tag icon={<TagShareIcon />} tooltip="Shared" />}
          {row?.original?.isLocked && <Tag icon={<TagLockIcon />} tooltip="Locked" />}
          {Number(status) === customGroupStatus.COMPLETED && isCompatible && (
            <Tag icon={<BookBookmarkIcon />} tooltip="Compatible Custom Group" />
          )}
        </span>
      );
    },
    disableSortBy: true,
    Header: 'Tags',
    width: 100,
  },
  {
    accessor: 'creator',
    Header: 'Creator',
    width: 100,
  },
  {
    accessor: 'created_datetime',
    Cell: ({ row }) => {
      return new Date(row?.original?.createdDatetime).toLocaleDateString('en-us', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      });
    },
    Header: 'Created',
    width: 100,
  },
];

export const getFilterOptions = () => [
  {
    label: 'Creator',
    options: [
      {
        label: 'Created by Me',
        value: 'created_by_me_all',
      },
      {
        label: 'Created by Others',
        value: 'created_by_others_all',
      },
    ],
  },
  {
    label: 'Product Groups',
    options: [
      {
        label: 'Shared Group',
        value: 'is_shared_item',
      },
      {
        label: 'Compatible Custom Group',
        value: 'is_narratives_compatible_item',
      },
    ],
  },
];
